"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const state = {
    zendeskKey: [
        "notice",
        "virtualAssets",
        "media",
        "useInformation",
        "faq",
        "customerCenter",
        "depositWithdrawInfo",
        "joinInfo",
        "depositWithdrawInfo",
        "term",
        "policy",
        "serviceOperationPolicy",
        "significant",
        "listingInquiries",
        "recruitment",
        "identificationForeign",
        "identification",
        "uniqueIdentifyForeign",
        "uniqueIdentifyKorea",
        "kycInformation",
        "joinFication",
        "acceptTransaction",
        "marketing",
        "disclosure",
        "authNotification",
        "tokenSwapTerms",
        "tokenSwapBanCountries",
    ],
    zendeskUrl: {
        ko: null,
        en: null,
        ch: null,
    },
    whiteListModalData: null,
};
const mutations = {
    SET_ZENDESK_URL(state, data) {
        state.zendeskUrl[data.local] = Object.assign(Object.assign({}, state.zendeskUrl[data.local]), data.keyObj);
    },
    SET_WHITELIST_MODAL(state, data) {
        state.whiteListModalData = data;
    },
};
const actions = {
    AC_ZENDESK_URL({ state, commit }) {
        return __awaiter(this, void 0, void 0, function* () {
            const isLiveServer = window.location.hostname === "m.flybit.com" ||
                window.location.hostname === "m.v1.flybit.com";
            const instance = axios_1.default.create({
                baseURL: isLiveServer
                    ? "https://third.flybit.com"
                    : "https://third.dev.flybit.com",
                timeout: 1000,
            });
            try {
                const { data } = yield instance.get(`/remote`);
                const baseUrl = "//flybit.zendesk.com";
                for (let local in state.zendeskUrl) {
                    state.zendeskKey.forEach((key) => {
                        let OjtCopy = {};
                        const localKey = local;
                        let value = data.result[key].value;
                        value = value.replace("%s", localKey);
                        const keyObj = {
                            [key]: `${baseUrl}${value}`,
                        };
                        commit("SET_ZENDESK_URL", { local, keyObj });
                    });
                }
            }
            catch (error) {
                commit("SET_ZENDESK_URL", { local: "ko", keyObj: { error: true } });
                console.log("error", error);
            }
        });
    },
    AC_WHITELIST_MODAL({ commit }, { key }) {
        return __awaiter(this, void 0, void 0, function* () {
            const isLiveServer = window.location.hostname === "m.flybit.com" ||
                window.location.hostname === "m.v1.flybit.com";
            const instance = axios_1.default.create({
                baseURL: isLiveServer
                    ? "https://third.flybit.com"
                    : "https://third.dev.flybit.com",
                timeout: 1000,
            });
            try {
                const { data } = yield instance.get(`/remote`);
                let whiteListObj = data.result[key];
                console.log("whiteListObj", whiteListObj);
                commit("SET_WHITELIST_MODAL", whiteListObj.whiteList);
            }
            catch (error) {
                commit("SET_WHITELIST_MODAL", null);
                console.log("error", error);
            }
        });
    },
};
exports.default = {
    namespaced: true,
    state,
    mutations,
    actions,
};
